// CAMP Inc. — public-safe organization information.
//
// SECURITY: Do NOT add D-U-N-S, EIN, or any non-public registry identifiers
// to this file. This file is bundled into the client and is fully readable
// from the browser. Add a value here only if it appears on a public Ohio
// Secretary of State business record or on official public materials.

export const COMPANY_NAME = 'Career Apprenticeship and Mentorship Program Inc.';
export const COMPANY_SHORT = 'CAMP Inc.';
export const COMPANY_TAGLINE = "Career pathways for Canton's next generation";

export const COMPANY_CITY = 'Canton';
export const COMPANY_STATE = 'OH';
export const COMPANY_LOCATION = 'Canton, Ohio';
export const COMPANY_ADDRESS_FULL = '1400 Broad Ave NW, Canton, OH 44708-3129';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=1400+Broad+Ave+NW%2C+Canton%2C+OH+44708-3129';

// Public Ohio Secretary of State record. Charter # and effective date are
// part of the public business filing and are safe to display.
export const ORG_TYPE = 'Ohio Domestic Nonprofit Corporation';
export const CHARTER_NUMBER = '5111478';
export const EFFECTIVE_DATE = 'September 13, 2023';
export const FOUNDING_YEAR = '2023';

// Mission text — verbatim from Articles of Incorporation. Do not paraphrase.
export const MISSION =
  'To offer Early College High School students of the Canton City school system comprehensive business and development training through career apprenticeship and mentorship programs as well as other support programs.';

export const MISSION_SHORT =
  'Comprehensive business and development training through career apprenticeship and mentorship for Canton City Early College High School students.';

// Until the IRS grants 501(c)(3) determination, this notice MUST stay near
// any "give / support / donate" call-to-action.
export const TAX_NOTICE =
  '501(c)(3) federal tax-exempt status with the IRS is pending. Donations may not yet be tax-deductible.';

// Contact placeholder — swap when CAMP provisions a real domain inbox.
export const CONTACT_EMAIL = 'info@campcanton.org';

export const FACTS = [
  { label: 'Founded',      value: '2023' },
  { label: 'Headquarters', value: 'Canton, OH' },
  { label: 'Status',       value: 'Ohio Nonprofit' },
];

export const PROGRAMS = [
  {
    id: 'apprenticeship',
    title: 'Career Apprenticeship',
    summary:
      'Hands-on workplace training with Canton-area employers — students learn business operations alongside professionals.',
    bullets: [
      'Real workplace experience',
      'Industry-aligned skills',
      'Defined career pathways',
    ],
  },
  {
    id: 'mentorship',
    title: 'Mentorship',
    summary:
      '1-on-1 pairing with established professionals who guide students through career exploration and personal development.',
    bullets: [
      'Monthly 1-on-1 sessions',
      'Career exploration support',
      'Personal development coaching',
    ],
  },
  {
    id: 'support',
    title: 'Support Programs',
    summary:
      'Wraparound support including study skills, financial literacy, and college readiness for Early College High School students.',
    bullets: [
      'Study and time-management skills',
      'Financial literacy',
      'College and career readiness',
    ],
  },
];

export const HOW_IT_WORKS = [
  {
    step: '01',
    title: 'Apply',
    body: 'Eligible Early College High School students of the Canton City school system submit interest with a brief application.',
  },
  {
    step: '02',
    title: 'Match',
    body: 'We pair each student with a mentor and an apprenticeship host based on their interests and goals.',
  },
  {
    step: '03',
    title: 'Launch',
    body: 'Students train, build a portfolio of real work, and step confidently into a defined career pathway.',
  },
];

export const GET_INVOLVED = [
  {
    audience: 'Students',
    cta: 'Apply',
    body: 'Open to Early College High School students of the Canton City school system.',
    subject: 'Student Application — CAMP Inc.',
  },
  {
    audience: 'Mentors',
    cta: 'Volunteer',
    body: 'Professionals who can give 2–4 hours per month guiding a student through career and life decisions.',
    subject: 'Mentor Volunteer Inquiry — CAMP Inc.',
  },
  {
    audience: 'Partners',
    cta: 'Sponsor',
    body: 'Employers, foundations, and community partners who can host an apprentice or fund the program.',
    subject: 'Partnership Inquiry — CAMP Inc.',
  },
];

export const NAV_ITEMS = [
  { label: 'About',        href: '#about' },
  { label: 'Programs',     href: '#programs' },
  { label: 'How It Works', href: '#process' },
  { label: 'Get Involved', href: '#get-involved' },
  { label: 'Contact',      href: '#contact' },
];
